var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlug = function SvgPlug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M4.918 1c.721 0 1.306.585 1.306 1.306v2.612h2.612V2.306a1.306 1.306 0 1 1 2.612 0v2.612h1.306c.721 0 1.306.585 1.306 1.306v3.918a6.53 6.53 0 0 1-13.06 0V6.224c0-.721.585-1.306 1.306-1.306h1.306V2.306C3.612 1.585 4.197 1 4.918 1m5.198 6.53h1.332v2.612a3.918 3.918 0 1 1-7.836 0V7.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.5 15h-2v4a1 1 0 0 0 1 1H16a1 1 0 1 0 0-2H8.5z"
  })));
};
export default SvgPlug;